import { omit } from 'lodash';

import { ParamsShopConfig, ShopConfig } from '../../models';

export const normalizeValues = (values: ShopConfig): ParamsShopConfig => {
  return omit(values, ['id', 'isSavedForFirstTime']);
};
